import { API_BASE_URL, API_PATHS } from "../constants/api.constants";

const convertImageToJpg = (file) => {
  return new Promise((resolve) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (event) => {
      img.src = event.target.result;
    };

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        (blob) => {
          const jpgFile = new File(
            [blob],
            file.name.replace(/\.\w+$/, ".jpg"),
            { type: "image/jpeg" }
          );
          resolve(jpgFile);
        },
        "image/jpeg",
        0.9
      );
    };

    reader.readAsDataURL(file);
  });
};

export const uploadImage = async (file, token) => {

  let uploadFile = file;

  // convert unsupported formats to jpg
  if (
    file.type === "image/webp" ||
    file.type === "image/png" ||
    file.type === "image/heic"
  ) {
    uploadFile = await convertImageToJpg(file);
  }

  const formData = new FormData();
  formData.append("file", uploadFile);

  const response = await fetch(`${API_BASE_URL}${API_PATHS.userUploadFile}`, {
    method: "POST",
    body: formData,
    headers: {
      "x-access-token": token,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to upload image");
  }

  const data = await response.json();

  if (data?.data?.location) {
    return data.data.location;
  }

  throw new Error(data.message || "Upload error");
};

export const uploadFile = async (file, token) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE_URL}${API_PATHS.uploadFile}`, {
    method: "POST",
    body: formData,
    headers: {
      "x-access-token": token,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to upload image");
  }

  const data = await response.json();
 

  if (data?.data?.location) {
    return data.data.location;
  }

  throw new Error(data.message || "Upload error");
};
